import * as BasicTextStyles from "./BasicText.module.css"

import { RichTextExt, blockPluginConstructor, markPluginConstructor, plugins, types } from "react-bricks/frontend"

import React from "react"

const BasicText: types.Brick = () => {
    const { unorderedList, link, bold } = plugins

    // for legacy reasons, to not break the existing projects font-sizes this needs to be a block-plugin
    const headingSize1 = blockPluginConstructor({
        name: "h1",
        render: ({ children }) => <>{children}</>,
    })

    // because headingSize must be a block-plugin for legacy reasons
    // and only one block-plugin can be used for a selected text, this needs to be a mark-plugin
    const heading1 = markPluginConstructor({
        name: "heading1",
        render: ({ children }) => <h1>{children}</h1>,
    })

    const headingSize2 = blockPluginConstructor({
        name: "h2",
        render: ({ children }) => <>{children}</>,
    })

    const heading2 = markPluginConstructor({
        name: "heading2",
        render: ({ children }) => <h2>{children}</h2>,
    })

    const headingSize3 = blockPluginConstructor({
        name: "h3",
        render: ({ children }) => <>{children}</>,
    })

    const heading3 = markPluginConstructor({
        name: "heading3",
        render: ({ children }) => <h3>{children}</h3>,
    })

    const headingSize4 = blockPluginConstructor({
        name: "h4",
        render: ({ children }) => <>{children}</>,
    })

    const heading4 = markPluginConstructor({
        name: "heading4",
        render: ({ children }) => <h4>{children}</h4>,
    })

    return (
        <section>
            <div className={BasicTextStyles.block}>
                <RichTextExt
                    propName="text"
                    renderBlock={({ children }) => <p>{children}</p>}
                    plugins={[
                        heading1,
                        headingSize1,
                        heading2,
                        headingSize2,
                        heading3,
                        headingSize3,
                        heading4,
                        headingSize4,
                        unorderedList,
                        link,
                        bold,
                    ]}
                />
            </div>
        </section>
    )
}

BasicText.schema = {
    name: "BasicText",
    label: "Basic Text",
}

export default BasicText
